import ListingCard, { TProps } from 'components/ListingCard'
import { Listing } from 'graphql/types'
import useMediaQuery from 'hooks/useMediaQuery'
import useMap from 'hooks/useMap'
import { getAppVersion } from 'lib/experiment'
import { ListingSchema } from 'config/schemas'
import {
  getListingDescription,
  getListingThumbnailUrl,
  getListingTitle,
  getListingUrl,
} from 'lib/listing'
import {
  cardClickEvent,
  cardGalleryEvent,
  favoriteListingSearchEvent,
} from '../events'

const SearchListingCard = ({
  listing,
  cardProps,
}: {
  listing: Listing
  cardProps?: TProps
}) => {
  const [slide, { set: setSlide }] = useMap({
    prev: false,
    next: false,
  })
  const isDeskResolution = useMediaQuery('(min-width: 1024px)')

  const isWebview = !!getAppVersion()

  const listingTitle = getListingTitle(listing)
  const listingDescription = getListingDescription(listing)
  const listingUrl = `https://emcasa.com${getListingUrl(listing)}`
  const listingThumbnailUrl = getListingThumbnailUrl(listing)

  const handleListingSlide = (type: 'prev' | 'next') => {
    setSlide(type, true)
    if (!slide[type]) cardGalleryEvent(listing.id as string, type)
  }

  return (
    <>
      <script
        type="application/ld+json"
        data-testid={`listingSchemaScript_${listing.id as string}`}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            ListingSchema({
              name: listingTitle,
              schemaDescription: listingDescription,
              image: listingThumbnailUrl,
              url: listingUrl,
              ...listing,
            }),
          ),
        }}
      />
      <ListingCard
        listing={listing || {}}
        targetBlank={isDeskResolution && !isWebview}
        onClick={() => cardClickEvent(listing.id as string)}
        onCarouselSlideTo={(_, button) => handleListingSlide(button)}
        onFavorite={() => favoriteListingSearchEvent(listing)}
        {...cardProps}
      />
    </>
  )
}

export default SearchListingCard
